import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, inject } from '@angular/core';
import { ModalFormContainerComponent } from '../../ui/modal-form-container/modal-form-container.component';
import { IContact, ITag } from '../../../types/contactModule';
import { ContactsService } from '../../../services/contacts/contacts.service';
import { GroupPickerComponent } from '../../organization/contacts/group-picker/group-picker.component';
import { formatCount } from '../../../../utils/sms';

/** Tags saved contacts in bulk (bulk action on contact lists). */
@Component({
  selector: 'assign-multiple-contacts-to-tags',
  standalone: true,
  imports: [ModalFormContainerComponent, GroupPickerComponent],
  templateUrl: './assign-multiple-contacts-to-tags.component.html',
  styleUrls: [
    '../../organization/contacts/group-picker/group-modal.css',
    './assign-multiple-contacts-to-tags.component.css',
  ],
})
export class AssignMultipleContactsToTagsComponent implements OnChanges {
  @Input() open: boolean = false;
  @Input() selectedContacts: IContact[] = [];
  @Input() selection: ITag[] = [];
  @Output() close = new EventEmitter();
  @Output() resetSelectedContacts = new EventEmitter();
  @Output() updateSelection = new EventEmitter<ITag[]>();

  // services
  contactService = inject(ContactsService);

  selectedTags: ITag[] = [];
  saving = false;
  errorMsg = '';

  get contactLabel(): string {
    const count = this.selectedContacts?.length ?? 0;
    return count === 1 ? '1 contact' : `${formatCount(count)} contacts`;
  }

  get submitLabel(): string {
    const count = this.selectedTags.length;
    if (this.saving) return 'Adding…';
    if (!count) return 'Choose tags';
    return count === 1 ? 'Add 1 tag' : `Add ${count} tags`;
  }

  onPick(items: any[]) {
    this.selectedTags = items as ITag[];
    this.errorMsg = '';
    this.updateSelection.emit(this.selectedTags);
  }

  handleSubmit() {
    if (!this.selectedTags.length || this.saving) return;
    this.saving = true;
    this.errorMsg = '';
    const tagCount = this.selectedTags.length;
    const label = this.contactLabel;
    this.contactService
      .assignMultipleContactsToTags(
        this.selectedContacts.map((el) => el.uuid as string),
        this.selectedTags.map((el) => el.uuid as string)
      )
      .subscribe({
        next: () => {
          this.saving = false;
          this.contactService.showSuccess(
            `Tagged ${label} with ${tagCount === 1 ? '1 tag' : `${tagCount} tags`}.`
          );
          this.resetSelectedContacts.emit();
          this.closeModal();
        },
        error: () => {
          this.saving = false;
          this.errorMsg = 'The tags were not added. Check your connection and try again.';
        },
      });
  }

  closeModal() {
    this.close.emit();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['open'] || changes['selection']) {
      this.selectedTags = [...(this.selection ?? [])];
      this.errorMsg = '';
      this.saving = false;
    }
  }
}
